<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">中标候选人公示列表</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="winCandidateList" border style="width: 100%" class="data-table" v-loading="loading">
                <el-table-column prop="winCandidateBulletinCode" label="公示编号" show-overflow-tooltip />
                <el-table-column prop="winCandidateBulletinName" label="公示名称" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="startTime" label="开始时间" width="180" align="center" />
                <el-table-column prop="endTime" label="结束时间" width="180" align="center" />
                <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" size="small">
                            {{ getStatusName(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)" class="action-btn">
                            查看详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination-wrapper">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" background />
            </div>
        </div>

        <!-- 详情弹窗 -->
        <el-dialog :visible.sync="detailDialogVisible" title="中标候选人公示详情" width="50%" :close-on-click-modal="false">
            <div class="detail-content" v-loading="detailLoading">
                <el-descriptions :column="2" border>
                    <el-descriptions-item label="公示编号" :span="2">
                        {{ winCandidateDetail.winCandidateBulletinCode || '-' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="公示标题" :span="2">
                        {{ winCandidateDetail.winCandidateBulletinName || '-' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="公示类型">
                        {{ getTypeName(winCandidateDetail.typeCode) }}
                    </el-descriptions-item>
                    <el-descriptions-item label="状态">
                        <el-tag :type="getDetailStatusType(winCandidateDetail.status)" size="small">
                            {{ getDetailStatusName(winCandidateDetail.status) }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="项目编号" :span="2">
                        {{ winCandidateDetail.projectCode || '-' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="公示时间">
                        {{ winCandidateDetail.startTime || '-' }} 至 {{ winCandidateDetail.endTime || '-' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="关联标段" :span="2">
                        <div class="section-wrapper">
                            <div v-if="winCandidateDetail.sections && winCandidateDetail.sections.length" class="section-list" :class="{'section-collapsed': sectionExpanded}">
                                <div v-for="(section, index) in winCandidateDetail.sections" :key="index" class="section-item">
                                    <span class="section-name" :title="section.bidSectionName">{{ section.bidSectionName }}</span>
                                    <span class="section-divider">-</span>
                                    <span class="section-code">{{ section.bidSectionCode }}</span>
                                </div>
                            </div>
                            <span v-else>-</span>
                            <div v-if="winCandidateDetail.sections && winCandidateDetail.sections.length > 5" class="expand-btn">
                                <el-button type="text" size="small" @click="sectionExpanded = !sectionExpanded">
                                    {{ sectionExpanded ? '收起' : '展开' }}
                                    <i :class="sectionExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                </el-button>
                            </div>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="公示内容" :span="2">
                        <div class="content-box" v-html="winCandidateDetail.winCandidateBulletinContent || '-'"></div>
                    </el-descriptions-item>
                    <el-descriptions-item label="附件列表" :span="2">
                        <div v-if="fileList && fileList.length" class="file-list">
                            <div v-for="(file, index) in fileList" :key="index" class="file-item">
                                <i :class="getFileIcon(file.fileExtension)"></i>
                                <span class="file-name" :title="file.fileName">{{ file.fileName }}</span>
                                <span class="file-size">({{ formatFileSize(file.fileSize) }})</span>
                                <el-button type="text" size="small" @click="handleDownload(file)" class="download-btn">
                                    下载
                                </el-button>
                            </div>
                        </div>
                        <span v-else>-</span>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Api_GetWinCandidateList, Api_GetWinCandidateDetail } from '@/api/modules/semiProcess'
import { getFileList } from '@/api/modules/base'
export default {
    name: 'WinCandidateList',
    data() {
        return {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            projectCode: this.$route.query.projectCode,
            winCandidateList: [],
            loading: false,
            detailLoading: false,
            detailDialogVisible: false,
            winCandidateDetail: {},
            fileList: [],
            sectionExpanded: false
        }
    },
    mounted() {
        this.getWinCandidateList()
    },
    methods: {
        /**
         * 获取中标候选人公示列表
         */
        getWinCandidateList() {
            this.loading = true
            Api_GetWinCandidateList({
                projectCode: this.projectCode,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.winCandidateList = res.data.records || []
                    this.total = res.data.total || 0
                } else {
                    this.$message.error(res.msg || '获取中标候选人公示列表失败')
                }
            }).catch(() => {
                this.loading = false
            })
        },

        /**
         * 获取中标候选人公示详情
         */
        getWinCandidateDetail(winCandidateBulletinCode) {
            this.detailLoading = true
            this.detailDialogVisible = true
            this.fileList = []
            Api_GetWinCandidateDetail({
                winCandidateBulletinCode: winCandidateBulletinCode
            }).then(res => {
                this.detailLoading = false
                if (res.code === 200) {
                    this.winCandidateDetail = res.data || {}
                    if (res.data && res.data.fileGuid) {
                        this.getFileList(res.data.fileGuid)
                    }
                } else {
                    this.$message.error(res.msg || '获取中标候选人公示详情失败')
                }
            }).catch(() => {
                this.detailLoading = false
                this.$message.error('获取中标候选人公示详情失败')
            })
        },

        /**
         * 获取文件列表
         */
        getFileList(fileId) {
            if (!fileId) {
                this.fileList = []
                return
            }
            getFileList(fileId).then(res => {
                if (res.code === 200) {
                    this.fileList = res.data || []
                } else {
                    this.$message.error(res.msg || '获取文件列表失败')
                    this.fileList = []
                }
            }).catch(() => {
                this.$message.error('获取文件列表失败')
                this.fileList = []
            })
        },

        // 格式化文件大小
        formatFileSize(size) {
            if (!size) return '0 B'
            const units = ['B', 'KB', 'MB', 'GB', 'TB']
            let index = 0
            let fileSize = size
            while (fileSize >= 1024 && index < units.length - 1) {
                fileSize /= 1024
                index++
            }
            return fileSize.toFixed(2) + ' ' + units[index]
        },

        // 根据文件扩展名获取图标
        getFileIcon(extension) {
            const iconMap = {
                'pdf': 'el-icon-document',
                'doc': 'el-icon-document',
                'docx': 'el-icon-document',
                'xls': 'el-icon-s-grid',
                'xlsx': 'el-icon-s-grid',
                'ppt': 'el-icon-s-data',
                'pptx': 'el-icon-s-data',
                'txt': 'el-icon-document',
                'zip': 'el-icon-folder-opened',
                'rar': 'el-icon-folder-opened',
                'jpg': 'el-icon-picture',
                'jpeg': 'el-icon-picture',
                'png': 'el-icon-picture',
                'gif': 'el-icon-picture'
            }
            return iconMap[extension?.toLowerCase()] || 'el-icon-document'
        },

        // 下载文件
        handleDownload(file) {
            if (file.fileUrl) {
                window.open(file.fileUrl, '_blank')
            } else {
                this.$message.error('文件下载链接不存在')
            }
        },

        // 状态名称映射
        getStatusName(status) {
            const statusMap = {
                0: '未发布',
                1: '待发布',
                2: '已发布',
                3: '已撤回',
                9: '已完成'
            }
            return statusMap[status] || '未知'
        },

        // 状态标签类型
        getStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'warning',
                2: 'success',
                3: 'danger',
                9: 'success'
            }
            return typeMap[status] || 'info'
        },

        // 详情页状态名称映射
        getDetailStatusName(status) {
            const statusMap = {
                0: '暂存',
                1: '提交',
                9: '发布'
            }
            return statusMap[status] || '未知'
        },

        // 详情页状态标签类型
        getDetailStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'warning',
                9: 'success'
            }
            return typeMap[status] || 'info'
        },

        // 公示类型名称映射
        getTypeName(typeCode) {
            const typeMap = {
                0: '正常公示',
                1: '更正',
                2: '其他'
            }
            return typeMap[typeCode] || '-'
        },

        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },

        // 查看详情
        handleView(row) {
            this.getWinCandidateDetail(row.winCandidateBulletinCode)
        },

        // 每页条数变化
        handleSizeChange(val) {
            this.pageSize = val
            this.pageNum = 1
            this.getWinCandidateList()
        },

        // 当前页变化
        handleCurrentChange(val) {
            this.pageNum = val
            this.getWinCandidateList()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @primary-color;
            border-radius: 2px;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

.table-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
}

.pagination-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

/deep/ .action-btn {
    font-weight: 500;

    &:hover {
        color: @primary-color;
    }
}

.detail-content {
    max-height: 60vh;
    overflow-y: auto;
    padding: 10px 0;

    .content-box {
        padding: 12px;
        background: #f5f7fa;
        border-radius: 4px;
        line-height: 1.8;
        max-height: 300px;
        overflow-y: auto;

        /deep/ p {
            margin: 0 0 10px 0;
        }

        /deep/ table {
            border-collapse: collapse;
            width: 100%;
            margin: 10px 0;

            td, th {
                border: 1px solid #dcdfe6;
                padding: 8px;
            }
        }
    }

    .section-item {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 4px 10px;
        margin: 2px;
        background: #f5f7fa;
        border-radius: 4px;
        font-size: 13px;

        .section-divider {
            color: #c0c4cc;
        }
    }

    .section-wrapper {
        .section-list {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            max-height: none;
            overflow: hidden;

            &.section-collapsed {
                max-height: 120px;
                overflow: hidden;
                position: relative;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 30px;
                    background: linear-gradient(transparent, #fff);
                }
            }

            .section-item {
                flex-shrink: 0;

                .section-name {
                    max-width: 200px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .section-code {
                    color: #909399;
                    font-size: 12px;
                }
            }
        }

        .expand-btn {
            margin-top: 4px;
            text-align: center;
        }
    }

    .file-list {
        .file-item {
            display: flex;
            align-items: center;
            padding: 6px 0;
            border-bottom: 1px dashed #ebeef5;

            &:last-child {
                border-bottom: none;
            }

            i {
                font-size: 16px;
                color: #409eff;
                margin-right: 8px;
            }

            .file-name {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #606266;
            }

            .file-size {
                color: #909399;
                font-size: 12px;
                margin: 0 10px;
            }

            .download-btn {
                color: #409eff;
                font-size: 12px;
            }
        }
    }
}
</style>